import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useToastStore = defineStore('toast', () => {
  const message = ref('')
  const type = ref('info') // success, error, info, warn
  const visible = ref(false)
  const duration = ref(3000)

  let timeoutId = null

  function show(newMessage, newType = 'info', newDuration = 3000) {
    message.value = newMessage
    type.value = newType
    duration.value = newDuration
    visible.value = true

    if (timeoutId) clearTimeout(timeoutId)

    timeoutId = setTimeout(() => {
      visible.value = false
    }, duration.value)
  }

  function hide() {
    visible.value = false
  }

  return {
    message,
    type,
    visible,
    duration,
    show,
    hide
  }
})